// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__qra-g","list_item":"styles_list_item__3JrDa","more":"styles_more__36o30"};